<template>
  <auth :title="t('confirmTitle')" :sub-title="t('confirmDescription')">
    <a-form
      :model="formState"
      :validate-messages="validateMessages"
      @finish="onConfirm"
    >
      <a-form-item
        :name="['password']"
        :label="t('password')"
        :rules="[{ required: true }, { validator: useRequiredChars }]"
      >
        <va-input
          v-model="formState.password"
          :placeholder="t('password')"
          type="password"
        />
      </a-form-item>
      <a-form-item
        :name="['repeatPassword']"
        :label="t('repeatPassword')"
        :rules="[{ required: true }, { validator: matchingPasswords }]"
      >
        <va-input
          v-model="formState.repeatPassword"
          :placeholder="t('repeatPassword')"
          type="password"
        />
      </a-form-item>

      <div class="flex items-center justify-between mb-6 -mt-3">
        <div class="flex items-center"></div>
        <div class="text-sm">
          <router-link
            to="/auth/signin"
            class="font-medium text-indigo-600 hover:text-indigo-500"
          >
            {{ t("forgotBack") }}
          </router-link>
        </div>
      </div>

      <div>
        <va-button
          :loading="authStore.isLoading"
          :disabled="dataError"
          class="w-full flex justify-center"
          html-type="submit"
        >
          {{ t("confirmPassCta") }}
        </va-button>
      </div>
    </a-form>
  </auth>
</template>

<script setup lang="ts">
import { reactive, ref, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import VaButton from "@/components/molecules/VaButton.vue";
import {
  useValidationMessages,
  useRequiredChars,
} from "@/composables/validation";
import VaInput from "@/components/molecules/VaInput.vue";
import { useRoute } from "vue-router";
import Auth from "@/components/templates/Auth.vue";
import { useAuthStore } from "@/stores/auth";
import { useNotificationsStore } from "@/stores/notifications";
import { useMeta } from "vue-meta";

useMeta({
  title: "Confirm mail",
});
const validateMessages = useValidationMessages();

const { t } = useI18n();
const route = useRoute();
const authStore = useAuthStore();
const notifications = useNotificationsStore();

const matchingPasswords = (rule: unknown, value: string) => {
  return new Promise<void>((resolve, reject) => {
    value !== formState.password ? reject(t("rulesMatchPassword")) : resolve();
  });
};

const formState = reactive({
  password: "",
  repeatPassword: "",
});

const dataError = ref(false);

onBeforeMount(() => {
  if (!route.query?.mail || !route.query?.token) {
    notifications.error(t("confirmMailError"));
    dataError.value = true;
  }
});

async function onConfirm() {
  await authStore.confirmEmail(
    route.query.mail as string,
    route.query.token as string,
    formState.password
  );
}
</script>
